import React from 'react'
import { useTranslation } from 'react-i18next'
import { UserContextType } from '../../contexts/userContext'
import { TUser } from '../../types/commonTypes'
import { NewAccountWelcomeBanner } from './components/NewAccountWelcomeBanner'
import { NewDashboardWelcomeBanner } from './components/NewDashboardWelcomeBanner'
import { TrialEndBanner } from './components/TrialEndBanner'
import { getUserActiveDays, welcomeBannerIconSelector, welcomeBlockDataSelector } from './helpers'

type WelcomeBlockProps = Pick<UserContextType, 'updateUser'> & {
  user: TUser
}

export const WelcomeBlock: React.FC<WelcomeBlockProps> = ({ user, updateUser }) => {
  const { t } = useTranslation()

  const data = welcomeBlockDataSelector(user, t)
  const activeDays = getUserActiveDays(user.createdAt)

  const closeNewUiMessage = () => {
    updateUser({ key: 'ux3Shown', value: true })
  }

  if (!user.isTrial && activeDays < 22) {
    return <NewAccountWelcomeBanner data={data} icon={welcomeBannerIconSelector(activeDays)} language={user.language} />
  }

  if (user.isTrial) {
    return activeDays < 15 ? (
      <NewAccountWelcomeBanner data={data} icon={welcomeBannerIconSelector(activeDays)} language={user.language} />
    ) : (
      <TrialEndBanner data={data} />
    )
  }

  if (!user.ux3Shown) {
    return <NewDashboardWelcomeBanner onClose={closeNewUiMessage} />
  }

  return null
}
